<template>
  <table class="table grid-12" cellspacing="0" cellpadding="0">
    <tr>
      <th>Situação</th>
      <th @click="changeFilter('id_job', 0)" v-html="filterIcons('Job', 0)"></th>
      <th @click="changeFilter('status', 1)" v-html="filterIcons('Status', 1)"></th>
      <th @click="changeFilter('tipo_servico', 2)" v-html="filterIcons('Tipo Serviço', 2)" class="tableHide"></th>
     <!--  <th @click="changeFilter('codigo_chamado_cliente', 3)" v-html="filterIcons('Chamado', 3)"></th> -->
      <th @click="changeFilter('cliente', 3)" v-html="filterIcons('Cliente', 3)"></th>
      <th @click="changeFilter('cliente_cliente', 7)" v-html="filterIcons('Cliente do Cliente', 7)" class="ocultaComMapa"></th>
      <th @click="changeFilter('cidade', 4)" v-html="filterIcons('Cidade', 4)" class="tableHide"></th>
      <th @click="changeFilter('dh_agendamento_cliente', 5)" v-html="filterIcons('Agendamento', 5)"></th>
      <!-- <th @click="changeFilter('dh_chegada', 7)" v-html="filterIcons('Chegada', 7)" class="tableHide"></th> -->
      <!-- <th class="tableHide" v-if="jobs[0].duracao_atendimento">Duração</th> -->
      <!-- <th @click="changeFilter('nome_completo_doutor', 8)" v-html="filterIcons('Supporter', 8)" class="tableHide"></th> -->
      <!-- <th class="tableHide">Celular</th> -->
      <th @click="changeFilter('gd', 6)" v-html="filterIcons('Gestor Demanda', 6)" class="tableHide"></th>
      <th class="show-s text-center" width="60">Candidatos</th>
      <th class="show-s text-center" width="120">Ações</th>
      <th v-if="jobs[0].duracao_atendimento" class="tableHide">RAT</th>
    </tr>
    <tr v-for="(job, i) in jobsFilter" :key="'jobrow' + i">
      <td>
        <JobStatus :color="job.situacao" />
      </td>
      <td>{{ job.id_job }}</td>
      <td>{{ job.status.replace("Doutor", "Supporter") }}</td>
      <td class="tableHide">{{ job.tipo_servico }}</td>
      <!-- <td>{{ job.codigo_chamado_cliente }}</td> -->
      <td>{{ job.cliente }}</td>
      <td class="ocultaComMapa">{{ job.cliente_cliente }}</td>
      <td class="tableHide">{{ job.cidade }}</td>
      <td>  {{ new Date(job.dh_agendamento).toLocaleDateString('pt-BR').slice(0,10)}}<br/>
        {{ new Date(job.dh_agendamento).toLocaleTimeString('pt-BR').slice(0,5)}}</td>

     <!--  <td class="tableHide">
        {{
          job.dh_angendamento
          ? new Date(job.dh_chegada).toLocaleTimeString('pt-BR').slice(0,5)
          : ""
        }}
      </td> -->
      <!-- <td class="tableHide" v-if="jobs[0].duracao_atendimento">
        {{ job.duracao_atendimento }}
      </td> -->

     <!--  <td class="tableHide">{{ job.nome_completo_doutor }}</td>  -->
       <td class="tableHide">{{ job.gd }}</td>
     <!--  <td class="tableHide">{{ job.celular | phone }}</td> -->
     <td class="tc fb">{{job.candidatos}}</td>
      <td style="vertical-align:center;text-align: center;">
        <a :href="`/${user.perfil == 'funcionario' ? 'funcionario' : 'cliente'}/job/${job.id_job}`">
          <Button class="detail" layout="green-s">DETALHES</Button>
        </a>
        <Button v-if="job.status == 'Em trânsito' && job.ultima_coordenada_doutor" class="detail" layout="green-s pin"
          @click="map({ lat: job.latitude, lng: job.longitude }, job, true)">ACOMPANHAR</Button>
      </td>
      <td v-if="jobs[0].duracao_atendimento" class="tableHide">
        <a v-if="job.rat" :href="'portal/job/' + job.id_job + '/arquivo/' + job.rat" target="_blank">
          <i class="fa fa-file"></i>
        </a>
      </td>
    </tr>
  </table>
</template>

<script>
import TableFilter from "@/components/mixins/TableFilter";
import Button from "@/components/Button.vue";
import JobStatus from "@/components/JobStatus";
import { mapGetters } from "vuex";

export default {
  components: { Button, JobStatus },
  mixins: [TableFilter],
  computed: { ...mapGetters("user", ["user"]) },
  props: {
    jobs: {
      type: Array,
      required: true,
    },
    pager: {
      type: Number,
    },
    map: {
      type: Function,
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.table {
  color: $gray-6;
  padding-right: 55px;
  font-size: 13px;
  border-radius: 21px;

  button {
    font-size: 10px;
  }

  .pin {
    margin-top: 7px;
    background: $green-1;
  }

  tr {
    &:nth-child(even) {
      background: $white-9;
    }

    &:nth-child(odd) {
      background: $white;
    }
  }

  td,
  th {
    min-height: 48px;
    padding: 10px 2px;

    &:first-child {
      padding-left: 15px;
    }

    &:last-child {
      padding-right: 15px;
    }
  }

  th {
    background: $white;
    text-align: left;

    &:hover {
      color: $green-1;
      cursor: pointer;
    }
  }
}

.opened {
  .tableHide,
  .ocultaComMapa { // a coluna de cliente do cliente cabe na tabela inteira, não ao lado do mapa
    display: none;
  }
}

.tableHide {
  @media (max-width: $large) {
    display: none;
  }
}
</style>
